import cn from 'classnames';
import { WEBSITE_URL } from 'core-lib/data/common';
import { toPascalCase } from 'core-lib/utils/utils';
import { useEffect, useState } from 'react';
import useWindowSize from 'core-lib/hooks/useWindowResize';
import { VariantsListType } from 'src/modules/newCars/types';
import { getOptions } from 'src/modules/newCars/utils/helper';
import { BackButton, Chip, Modal, Typography } from 'ui';
import { TypeScales } from 'ui/primitives';
import { ChipVariants } from 'ui/primitives/ChipTypes';
import { VariantListingCard } from '../../cards/VariantListingCard/VariantListingCard';
import s from './AllVariants.module.scss';

export const AllVariants = ({
  show,
  onClose,
  variantsList,
  modelName,
  modelImage,
  setSelectedVariant,
  brandSlug,
  modelSlug,
  onSelect
}: {
  show: boolean;
  onClose: () => void;
  variantsList: VariantsListType[];
  modelName: string;
  modelImage: string;
  setSelectedVariant: (arg: VariantsListType) => void;
  brandSlug: string;
  modelSlug: string;
  onSelect?: (arg) => void;
}) => {
  const [activeFilter, setActiveFilter] = useState({ fuel: [], transmission: [] });
  const [filteredVariants, setFilteredVariants] = useState(variantsList);
  const [filterOptions, setFilterOptions] = useState(getOptions(variantsList));
  const { width, height } = useWindowSize();
  function handleFilterClick(type, value) {
    if (type === 'fuel') {
      if (activeFilter.fuel?.includes(value)) {
        setActiveFilter({ ...activeFilter, fuel: activeFilter?.fuel?.map((obj) => obj?.toLowerCase())?.filter((obj) => obj !== value) });
      }
      else {
        setActiveFilter({ ...activeFilter, fuel: [...activeFilter.fuel, value] });
      }
    }
    else if (type === 'transmission') {
      if (activeFilter?.transmission?.includes(value)) {
        setActiveFilter({ ...activeFilter, transmission: activeFilter?.transmission?.map((obj) => obj?.toLowerCase())?.filter((obj) => obj !== value) });
      }
      else {
        setActiveFilter({ ...activeFilter, transmission: [...activeFilter.transmission, value] });
      }
    }
  }
  useEffect(() => {
    if (activeFilter?.fuel?.length || activeFilter?.transmission?.length) {
      let tempFilteredVariants = variantsList?.filter((obj) => {
        if (activeFilter?.transmission?.length) {
          if (activeFilter?.transmission?.includes(obj?.transmission)) {
            return true;
          }
        }
        if (activeFilter?.fuel?.length) {
          if (activeFilter?.fuel?.includes((obj?.fuelType?.toLowerCase()))) {
            return true;
          }
        }
        return false;
      });
      setFilteredVariants(tempFilteredVariants);
    }
    else setFilteredVariants(variantsList);
  }, [activeFilter, variantsList]);

  function handleVariantClick(variant) {
    setSelectedVariant(variant);
    onSelect(variant);
    onClose();
  }

  return (
    <>
      {width > 800 ? <Modal
        show={show}
        isWeb
        head={{
          show: false,
          title: 'Select variant',
          onClose: onClose,
        }}
        closeOnClickOutside
        noPadding
        animation={{ type: 'fadeAfter', timeout: 's' }}
        variant="fullScreenPopup"
        customeBodyStyle={{
          height: '850px',
          minWidth: '800px',
        }}
        rootStyle={{ zIndex: 10 }}
      >
        <div className={s.root}>
          <div className={s.head}>
            <Typography
              label="Select variants"
              variant={TypeScales.h2}
              className={s.heading}
            />
            <div className={cn(s.back_btn, 'cmn_only_desktop')}>
              <BackButton onBack={() => onClose()} type="cross" />
            </div>
            <div className={s.filters}>
              {!!filterOptions?.fuel?.length && filterOptions.fuel?.map((obj) => (
                <div
                  className={cn('cmn_touchable_area', s.filter_btn)}
                  key={obj?.name}
                >
                  <Chip
                    onClick={() => handleFilterClick('fuel', obj.toLowerCase())}
                    variant={ChipVariants.Filter}
                    label={toPascalCase(obj)}
                    showCross
                    state={activeFilter?.fuel?.includes(obj.toLowerCase()) ? "selected" : "enabled"} />
                </div>
              ))}
              {!!filterOptions?.transmission?.length && filterOptions.transmission?.map((obj) => (
                <div
                  className={cn('cmn_touchable_area', s.filter_btn)}
                  key={obj?.name}
                >
                  <Chip
                    onClick={() => handleFilterClick('transmission', obj.toLowerCase())}
                    variant={ChipVariants.Filter}
                    label={toPascalCase(obj)}
                    showCross
                    state={activeFilter?.transmission?.includes(obj.toLowerCase()) ? "selected" : "enabled"} />
                </div>
              ))}
            </div>
          </div>
          <div className={s.list}>
            {filteredVariants?.length ? filteredVariants?.map((obj) => (
              <VariantListingCard
                variantDetail={obj}
                modelName={modelName}
                modelImage={modelImage}
                key={obj?.slug}
                onVariantClick={() => handleVariantClick(obj)}
                link={`${WEBSITE_URL}/new-cars/${brandSlug}-car/${modelSlug}/${obj?.slug}-variant`}
              />
            )) : (
              <Typography label="No variants found" variant={TypeScales.h3_light} style={{ marginTop: '40px', textAlign: 'center' }} />
            )}
          </div>
        </div>
      </Modal> :
        <Modal
          show={show}
          head={{
            show: true,
            title: 'Select variant',
            onClose: onClose,
          }}
          closeOnClickOutside
          animation={{ type: 'fadeAfter', timeout: 's' }}
          variant="page"
          rootStyle={{ zIndex: 2 }}
        >
          <div className={s.root_mobile}>
            <div className={s.head}>
              <Typography
                label="Select variants"
                variant={TypeScales.h2}
                className={s.heading}
              />
              <div className={s.filters}>
                {!!filterOptions?.fuel?.length && filterOptions.fuel?.map((obj) => (
                  <div
                    className={cn('cmn_touchable_area', s.filter_btn)}
                    key={obj?.name}
                  >
                    <Chip
                      onClick={() => handleFilterClick('fuel', obj.toLowerCase())}
                      variant={ChipVariants.Filter}
                      label={toPascalCase(obj)}
                      showCross
                      state={activeFilter?.fuel?.includes(obj.toLowerCase()) ? "selected" : "enabled"} />
                  </div>
                ))}
                {!!filterOptions?.transmission?.length && filterOptions.transmission?.map((obj) => (
                  <div
                    className={cn('cmn_touchable_area', s.filter_btn)}
                    key={obj?.name}
                  >
                    <Chip
                      onClick={() => handleFilterClick('transmission', obj.toLowerCase())}
                      variant={ChipVariants.Filter}
                      label={toPascalCase(obj)}
                      showCross
                      state={activeFilter?.transmission?.includes(obj.toLowerCase()) ? "selected" : "enabled"} />
                  </div>
                ))}
              </div>
            </div>
            <div className={s.list}>
              {filteredVariants?.length ? filteredVariants?.map((obj) => (
                <VariantListingCard
                  variantDetail={obj}
                  modelName={modelName}
                  modelImage={modelImage}
                  key={obj?.slug}
                  onVariantClick={() => handleVariantClick(obj)}
                  link={`${WEBSITE_URL}/new-cars/${brandSlug}-car/${modelSlug}/${obj?.slug}-variant`}
                />
              )) : (
                <Typography label="No variants found" variant={TypeScales.h3_light} style={{ marginTop: '40px', textAlign: 'center' }} />
              )}

            </div>
          </div>
        </Modal>
      }
    </>
  );
};
